import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'public-user', ['RESET']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'public_data',
  type: 'get',
  slug: [
    'users',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});
const defaultReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case consts.SEND: {
      return {
        ...state,
        ...initialState,
        sending: true,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        ...initialState,
        succeed: true,
        data: action.payload,
      };
    }

    case consts.RESET: {
      return initialState;
    }

    default:
      return defaultReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/profiles/public-profile.js